import {
  TSdkIntlShape,
  EVENT_INTLCHANGE_TYPE,
  isIntlChangeEvent,
} from '@tokenized/sdk-js-private';
import { useEffect, useState } from 'react';
import { useTokenizedApi } from '../useTokenizedApi';

/** @internal */
export function useIntl() {
  const tokenizedApi = useTokenizedApi();
  const [intl, setIntl] = useState<TSdkIntlShape>(tokenizedApi.intl.getIntl());

  useEffect(() => {
    const updateIntl: EventListener = (event) => {
      if (isIntlChangeEvent(event)) {
        setIntl(event.detail.intl);
      }
    };
    tokenizedApi.intl.addEventListener(EVENT_INTLCHANGE_TYPE, updateIntl);
    return () =>
      tokenizedApi.intl.removeEventListener(EVENT_INTLCHANGE_TYPE, updateIntl);
  }, [tokenizedApi.intl]);

  return intl;
}
